import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useConfig } from "@/lib/useConfig";
import { Button } from "@/components/ui/button";

export default function MarketingShell({ title, subtitle, children }) {
  const navigate = useNavigate();
  const config = useConfig();
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="shell-logo-link" className="flex items-center group">
            <img src="/citehub-logo.png" alt="Local CiteHub" width="120" height="50" className="h-9 w-auto transition-transform group-hover:-translate-y-0.5" />
          </Link>
          <div className="flex items-center gap-2">
            <Button variant="secondary" onClick={() => navigate("/login")} className="bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 h-10">Sign in</Button>
            <Button onClick={() => navigate("/login?signup=1")} className="bg-[#0055FF] hover:bg-[#0044CC] text-white h-10">Get started</Button>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#0055FF]">Local CiteHub</p>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-slate-900 mt-2">{title}</h1>
          {subtitle && <p className="mt-3 text-base text-slate-600">{subtitle}</p>}
          <div className="mt-10 prose-slate max-w-none text-slate-700 leading-relaxed space-y-6">{children}</div>
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <Link to="/contact" className="text-slate-600 hover:text-[#0055FF] font-medium">Contact</Link>
            <Link to="/support" className="text-slate-600 hover:text-[#0055FF] font-medium">Support</Link>
            <Link to="/privacy" className="text-slate-600 hover:text-[#0055FF] font-medium">Privacy</Link>
            <Link to="/terms" className="text-slate-600 hover:text-[#0055FF] font-medium">Terms</Link>
            <Link to="/refund" className="text-slate-600 hover:text-[#0055FF] font-medium">Cancellation & Refund</Link>
          </nav>
          <p className="text-sm text-slate-400">© {new Date().getFullYear()} Local CiteHub{config?.company_name ? ` · by ${config.company_name}` : ""}</p>
        </div>
      </footer>
    </div>
  );
}

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-display text-xl font-bold text-slate-900">{heading}</h2>
    <div className="mt-2 text-slate-600 space-y-3">{children}</div>
  </section>
);
